import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ContractSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ContractSVG;
